import React from 'react';
import {CSSTransition, Transition, TransitionGroup} from "react-transition-group";
import snake from '../../images/dschungel/snake.png'

import uuid from 'uuid'



function Snake(props) {

    const renderSheep = () => {
        if (props.show) {
            return  (

                <div>
                    <img src={snake} style={sheep}/>
                </div>


            )
        }
    }

    return(
        <TransitionGroup>
            <CSSTransition
                key={uuid()}
                timeout={600}
                classNames='fade'>
                {renderSheep}
            </CSSTransition>
        </TransitionGroup>

    )

}


export default Snake



const sheep = {
    position: 'fixed',
    zIndex: -1,
    maxHeight: '90%',
    maxWidth:'100%',
    left:'0',
    right:'0',
    top:'0',
    bottom:'0',
    margin:'auto'
}

